import React from 'react';
import { inject, observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

@observer
class StepNavigationComponent extends React.Component {
  render() {
    const {
      allSteps,
      activeSteps,
    } = this.props.ActiveStepsData;

    const stepsComponent = allSteps.map((step) => {
      let component;
      const stepNumber = step.slice(-1);
      const activeRoute = this.props.RouterData.activeRoute.slice(-1);

      if (stepNumber <= activeRoute || (activeRoute === '/' && stepNumber === '1')) {
        const activeRouteClass = (stepNumber === activeRoute || activeRoute === '/') ? 'tool-circle--active' : '';

        const stepVal = activeRoute === '/' ? 'step-1' : step;

        component = (
          <Link
            key={stepVal}
            to={`/${stepVal}`}
          >
            <div className={`stepnavigation__previous-current-step ${activeRouteClass}`}>
              {stepNumber}
            </div>
          </Link>
        );
      } else if (stepNumber > activeRoute && activeSteps.indexOf(step) > -1) {
        component = (
          <Link
            key={step}
            to={`/${step}`}
          >
            <div className={'stepnavigation__previous-current-step'}>
              {stepNumber}
            </div>
          </Link>
        );
      } else {
        component = (
          <div key={step} className="stepnavigation__next-steps">
            {stepNumber}
          </div>
        );
      }

      return component;
    });

    return (
      <div className={`${this.props.classNames} step-navigation-component`}>
        {stepsComponent}
      </div>
    );
  }
}

StepNavigationComponent.propTypes = {
  classNames: PropTypes.string,
  ActiveStepsData: PropTypes.shape({
    allSteps: PropTypes.arrayOf(PropTypes.string),
    activeSteps: PropTypes.arrayOf(PropTypes.string),
  }),
  RouterData: PropTypes.shape({
    activeRoute: PropTypes.string,
  }),
};

StepNavigationComponent.defaultProps = {
  classNames: '',
  ActiveStepsData: {
    allSteps: [],
    activeSteps: [],
  },
  RouterData: {
    activeRoute: '/',
  },
};

export default inject('RouterData', 'ActiveStepsData')(StepNavigationComponent);
